/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Elastic, Power2, Power3, Timeline, TimelineLite, TweenLite} from "gsap";
import {BarbarianFuryGameConfig} from "../../BarbarianFuryGameConfig";

export class BarbarianFuryBigWinCountUp extends BitmapWinCountUp {

    constructor(fontSize?: number) {
        super({
            font: {
                name: "NumbersWinCountUp",
                size: fontSize ? fontSize : 27
            },
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    public getCountUpAnimation(from: number, to: number, duration: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration: duration,
                ease: from == 0 ? Power3.easeInOut : Power2.easeOut
            }),
            TweenLite.fromTo(this._countUpContainer.scale, 1,
                {x: 0.5, y: 0.5},
                {
                    x: 1,
                    y: 1,
                    ease: Elastic.easeOut.config(2, 1)
                })
        ]);

        return timeline;
    }

    public getEndingAnimation(endValue: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01}));
        timeline.add(TweenLite.to(this._countUp, 0.2, {alpha: 0}), `+=0.8`); // stay a while after count up.

        return timeline;
    }

    public createCountUpIndividualWinSymCombController(): void {
        this.initAnimations();
    }

    protected initAnimations(): void {
        super.initAnimations();

        // #209
        this._countUp.maxTextWidth = BarbarianFuryGameConfig.instance.REEL_AREA_WIDTH * 0.93;
    }

    protected getAbortAnimation(endValue: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            TweenLite.fromTo(this._countUpContainer.scale, 0.2,
                {x: 0.5, y: 0.5},
                {
                    x: 1,
                    y: 1,
                    ease: Elastic.easeOut.config(2, 1)
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01})
        ]);

        return timeline;
    }
}